import React from 'react';
import { useSearchParams } from 'react-router-dom';
import * as api from '../../../api';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import dayjs from 'dayjs';
import FDFicheV2Projet from './FDFicheV2Projet';

const HeaderContainer = styled.div`
    background: white;
    border-bottom: 3px solid black;

    > div {
        margin: auto;
        width : min(1440px,100vw - 40px);
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 170px;

        > img {
            height: 50%;
        }
    }
`

const LanguageButton = styled.span`
    margin: 0;
    font-size: 21px;
    display: inline-block;
    text-decoration: none;

    &.selected {
        text-decoration: underline;
    }
`

const MainContainerSociété = styled.main`
    background: white;

    .capitalize {
        display: inline-block;
        &:first-letter {
            text-transform: capitalize;
        }
    }

    > div {
        margin: auto;
        width : min(1440px,100vw - 40px);

        > div.header {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            height: 333px;
            > h1 {
                margin-top: 100px;
                font-size: 70px;
                color: #000000;
            }
            > img {
                margin-top: 100px;
                max-height: 158px;
                max-width: 158px;
            }
        }

        > img.separator {
            margin-top: -25px;
            width: 100%;
            margin-bottom: 75px;
        }

        > div.imageTexte {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            padding-bottom: 75px;
            > div {
                width: calc(50% - 25px);
                > img {
                    display: block;
                    margin: auto;
                    max-height: 510px;
                    max-width: 100%;
                    margin-bottom: 20px;
                    filter: grayscale(100%);
                }
                > span {
                    font-size: 12px;
                    color: gray;
                }
            }
            > p {
                font-size: 20px;
                width: calc(50% - 25px);

                > div.socials {
                    display: flex;
                    flex-wrap: wrap;
                    margin: 45px 0;
                    gap: 20px;
                    > a {
                        font-size: 15px;
                        font-weight: bold;
                        color: white;
                        text-decoration: none;
                        text-transform: uppercase;
                        background-color: blue;
                        padding: 10px 20px;
                    }
                }

                > p {
                    white-space: pre-wrap;
                    display: -webkit-box;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 5; /* this can be any value you want */
                    &.deployed {
                        max-height: none;
                        -webkit-line-clamp: unset;
                    }
                }

                > span.lirePlus {
                    color: blue;
                    cursor: pointer;
                }
            }
        }
    }
`

const Label = styled.span`
    font-size: 15px;
    font-weight: bold;
    text-transform: uppercase;
`

function TranslateButton() {

    async function changeLanguage(lang) {
        i18n.changeLanguage(lang);
        dayjs.locale(lang);
        api.SwitchUserLang({lang : lang});
    }

    const {i18n} = useTranslation('common');
    return <div >
        <LanguageButton className={'linkbutton' + (i18n.language === "fr" ? ' selected' : '')} onClick={() => changeLanguage('fr')} style={{marginRight:"20px"}} >Français</LanguageButton>
        <LanguageButton className={'linkbutton' + (i18n.language === "en" ? ' selected' : '')} onClick={() => changeLanguage('en')} >English</LanguageButton>
    </div>
}

const Header = () => {
    return (
        <HeaderContainer>
            <div>
                <img alt="" src='/img/lfd100.png'/>
                <TranslateButton/>
            </div>
        </HeaderContainer>
    )
}

const FDFicheV2 = () => {

    const { i18n } = useTranslation('common');
    const [searchparams] = useSearchParams();
    const [user, setUser] = React.useState(null);
    const [selectedProject, setSelectedProject] = React.useState(null);
    const [otherProjects, setOtherProjects] = React.useState([]);
    const [sociétéDeployed, setSociétéDeployed] = React.useState(false);

    //get user data
    React.useEffect(() => {
        api.GetAllUserData({email:searchparams.get("email")}).then((response) => {
            console.log("found user")
            console.log(response.data)
            setUser(response.data)
        }).catch((error) => {
            console.log(error);
        });
    }, [])

    // get participation
    React.useEffect(() => {
        if(!user || user.participation) return;
        api.getUserParticipations({userid : user.user._id}).then((response) => {
            const _participation = response.data.find((_participation) => _participation._id === searchparams.get("pid"));
            console.log("found participation :")
            console.log(_participation)
            _participation.data = _participation.data || {}
            setUser({...user,participation:_participation});
            if(_participation.data.projets && _participation.data.projets.length > 0) {
                const selectedProject = _participation.data.projets.find((_project) => _project.status === 'validé');
                if(selectedProject){
                    setSelectedProject(selectedProject);
                }
                setOtherProjects(_participation.data.projets.filter((_project) => _project.status !== 'validé'));
            }
        }).catch((error) => {
            console.log(error);
        });
    },[user]);

    function translateClientèle(string,lang){
        if(lang === "fr"){
            return string;
        } else {
            if(string === "Particuliers") return "Individuals"
            if(string === "Professionnels") return "Professionals"
            if(string === "France") return "France"
            if(string === "Europe") return "Europe"
            if(string === "International") return "International"
        }
    }

    function transaltePositionnement(string,lang){
        if(lang === "fr"){
            return string;
        } else {
            if(string === "Entrée de gamme") return "Entry level"
            if(string === "Moyen de gamme") return "Mid-range"
            if(string === "Haut de gamme") return "High-end"
            if(string === "Luxe") return "Luxury"
        }
    }

    return (
        <div>
            <Header/>
            {user && user.participation && 
                <MainContainerSociété>
                    <div>
                        <div className='header'>
                            <h1>{user.hsProfile.company}</h1>
                            {user.user.logo && <img alt="" src={"https://mediacenter.lefrenchdesign.org/" + "userfiles/" + user.user.logo}/>}
                        </div>
                        <img alt="" className='separator' src='/img/ligne.png'/>
                        <div className='imageTexte'>
                            {user.user.portrait &&
                                <div>
                                    <img alt="" src={"https://mediacenter.lefrenchdesign.org/" + "userfiles/" + user.user.portrait}/>
                                    <span className="thin centered">© {user.hsProfile.credit_photo_et_legende}</span>
                                </div>
                            }
                            <p>
                                {user.hsProfile.annee_de_creation_de_l_entreprise && <>
                                    <Label>{i18n.language === "fr" ? "Année de création de l'entreprise" : "Company start year"}</Label><br/>
                                    <span className="thin capitalize">{user.hsProfile.annee_de_creation_de_l_entreprise}</span><br/><br/>
                                </>}
                                {user.hsProfile.clientele && <>
                                    <Label>{i18n.language === "fr" ? "Clientèle" : "Customer base"}</Label><br/>
                                    <span className='thin capitalize'>{user.hsProfile.clientele?.split(';').map(val => translateClientèle(val,i18n.language)).join(' / ')}</span><br/><br/>
                                </>}
                                {user.hsProfile.positionnement && <>
                                    <Label>{i18n.language === "fr" ? "Positionnement" : "Positioning"}</Label><br/>
                                    <span className='thin capitalize'>{user.hsProfile.positionnement?.split(';').map(val => transaltePositionnement(val,i18n.language)).join(' / ')}</span>
                                </>}
                                <div className='socials'>
                                    {user.hsProfile.website && 
                                        <a href={user.hsProfile.website} target="_blank" rel='noreferrer' className='thin'>{i18n.language === "fr" ? "Site web" : "Website"}</a>
                                    }
                                    {user.hsProfile.facebook &&
                                        <a href={user.hsProfile.facebook} target="_blank" rel='noreferrer' className='thin'>Facebook</a>
                                    }
                                    {user.hsProfile.instagram_account &&
                                        <a href={user.hsProfile.instagram_account} target="_blank" rel='noreferrer' className='thin'>Instagram</a>
                                    }
                                    {user.hsProfile.twitterhandle &&
                                        <a href={user.hsProfile.twitterhandle} target="_blank" rel='noreferrer' className='thin'>Twitter</a>
                                    }
                                    {user.hsProfile.lien_linkedin &&
                                        <a href={user.hsProfile.lien_linkedin} target="_blank" rel='noreferrer' className='thin'>Linkedin</a>
                                    }
                                    {user.hsProfile.pinterest &&
                                        <a href={user.hsProfile.pinterest} target="_blank" rel='noreferrer' className='thin'>Pinterest</a>
                                    }
                                </div>
                                <p className={'thin' + (sociétéDeployed ? ' deployed' : '')}>{i18n.language === "fr" ? user.hsProfile.presentation_de_l_entreprise_en_francais_500_signes_ : user.participation.data.presentation_entreprise_anglais}</p><br/>
                                {sociétéDeployed ?
                                    <span className='lirePlus thin' onClick={() => setSociétéDeployed(false)}>{i18n.language === "fr" ? "Afficher moins" : "Show less"}</span>
                                :
                                    <span className='lirePlus thin' onClick={() => setSociétéDeployed(true)}>→ {i18n.language === "fr" ? "Lire plus" : "Read more"}</span>
                                }
                            </p>
                        </div>
                    </div>
                </MainContainerSociété>
            }
            {user && user.participation && selectedProject &&
                <FDFicheV2Projet
                    selectedProject = { selectedProject }
                    otherProjects = { otherProjects }
                />
            }
        </div>
    );
};

export default FDFicheV2;